import {
  formatCurrency,
  formatPercentage,
} from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import { PriceTagIcon } from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';
import { DiscountAndFee } from '../../data-access/products';

interface DiscountSummaryProps {
  discount: DiscountAndFee;
  iconSize: string;
}

const DiscountSummary: React.FC<DiscountSummaryProps> = ({
  discount,
  iconSize,
}) => (
  <>
    <PriceTagIcon height={iconSize} width={iconSize} />
    <FlexBox flexDirection={'column'} flex={1}>
      <Typography variant={'subtitle2'}>{discount.displayName}</Typography>
      <Typography variant={'caption'} color={'text.secondary'}>
        {discount.amountType === 'PERCENTAGE'
          ? formatPercentage(discount.amount)
          : formatCurrency(discount.amount, 'USD')}
      </Typography>
    </FlexBox>
  </>
);

export default DiscountSummary;
